<template>

    <div class="page-container">
        <div class="d-flex justify-content-between">
            <h3>Entities</h3>
            <router-link class="text-decoration-none btn-container" v-if="permissions.includes('create entity') && this.entities.length > 0" to="/settings/entities/create">
                <span>Create Entity</span>
            </router-link>
        </div>
        <div class="my-4 entities-section">
            <p v-if="this.entities.length > 0" class="entity-title m-0">Parent Entity</p>
            <div v-else class="text-center tabcontent  tab-no-data-content">
                <div class="d-flex flex-column justify-content-center align-items-center gap-2 h-75 m-auto">
                    <h3>You Don't Have Any enetties Yet</h3>
                    <router-link class="text-decoration-none btn-container btn-container-no-data" v-if="permissions.includes('create entity') && this.entities.length === 0" to="/settings/entities/create">
                        <span>Create Entity</span>
                    </router-link>
                </div>

            </div>
            <div id="tree-id" class="entity-tree scrollbar" @click="clickHandler($event)"></div>

            <span v-if="lightMood"></span>
        </div>
    </div>
    <ConfirmationModal v-if="confirmModalFlag" :message="confirmMessage" confirmBtn="Delete" cancleBtn="Cancel"
                       @close-modal="confirmModalHandler($event)"/>

</template>

<script>
    import repository from "../../../api-services/repository";
    import {defineAsyncComponent} from "vue";

    const ConfirmationModal = defineAsyncComponent(() =>
        import ('../../components/ConfirmationModal')
    );
    export default {
        components: {ConfirmationModal},
        async mounted() {
            await this.$store.dispatch('activeTap', 'settings-entities');
            this.permissions = this.$store.state.auth.permissions;
            let entitiesData = await repository.index('entities', false, 'desc', false);
            this.entities = entitiesData.data.data;
            this.init();
            this.lightMood = this.$store.state.settings.isLightMood;
        },
        data() {
            return {
                entities: [],
                permissions:[],
                lightMood:null,
                parent: null,
                children: null,
                subChildren: null,
                confirmModalFlag: false,
                confirmMessage: '',
                entityId: ''
            }
        },
        computed:{
            lightMood(){
                console.log("entity lightMood")
                this.init();
                return this.$store.state.settings.isLightMood;
            }
        },
        methods: {
            async init() {
                let isLight = `${this.$store.state.settings.isLightMood}`;

                let entityTree = document.getElementById('tree-id');
                entityTree.innerHTML = ``;

                // console.log(entitiesData.data.data)

                // console.log(this.entities.length);
                if (this.entities.length > 0) {
                    this.entities.forEach((item) => {

                        if (item.parent_id === null) {

                            entityTree.innerHTML += `
                            <div class="parent">
                                <div  id="parent-container-${item.id}">
                                    <div class="d-flex justify-content-between allDivCss">
                                        <div id="parent-${item.id}" class="parentStyleEntity">
                                            <a id="btn-${item.id}">
                                                 <img class="img" id='img-${item.id}' src=${ isLight === 'true' ? require('../../../assets/images/angleRightColor.svg') : require('../../../assets/images/expand_more.png')} height="19">
                                                        ${item.name}
                                            </a>

                                        </div>
                                        <div class="action-container">
                                            <div  class="action delete-action" id="delete-action-${item.id}" style="padding: 10px">
                                                <img class="imgBorderHandler" src=${require('../../../assets/images/trash.svg')}>
                                            </div>
                                            <div  class="action edit-action" id="edit-action-${item.id}" style="padding: 10px">
                                                <img class="imgBorderHandler" src=${require('../../../assets/images/edit.svg')}>
                                            </div>
                                        </div>

                                        </div>
                                     </div>
                                     <div id=${item.id} style="display: none; border-left: 1px solid #E95626; padding-left: 20px" class="flex-column position-relative"><div class="parent-border"></div></div>
                              </div>
                        `;

                            if(!this.permissions.includes('delete entity')){
                                document.getElementById(`delete-action-${item.id}`).style.cssText = `
                                padding: 10px;
                                cursor: not-allowed;
                        `;
                            }

                            if(!this.permissions.includes('update entity')){
                                document.getElementById(`edit-action-${item.id}`).style.cssText = `
                                padding: 10px;
                                cursor: not-allowed;
                        `;
                            }

                            this.getAllChildrens(item);
                        }

                    });
                } else {
                    entityTree.innerHTML += `
<!--                        <div class="text-center">No Entities</div>-->
                    `;
                }
            },

            getAllChildrens(data) {
                let isLight = `${this.$store.state.settings.isLightMood}`;
                if (data['all_children']?.length > 0) {
                    data['all_children'].forEach((childItem, idx) => {
                        let children = document.getElementById(`${childItem.parent_id}`);
                        // console.log(`parent-${childItem.parent_id}`, children)
                        // console.log(" children =>> ", childItem)
                        // document.getElementById(`action-${childItem.parent_id}`).style.pointerEvents = 'none';
                        document.getElementById(`delete-action-${childItem.parent_id}`).style.cssText = `
                                padding: 10px;
                                cursor: not-allowed;
                        `;

                        children.innerHTML += `
                            <div class="children position-relative">
                                <span class="child-border"></span>
                                <div class="child-container childCssColor" id="child-container-${childItem.id}">
                                    <div class="d-flex justify-content-between">
                                    <div class="childrenBorderRight">
                                            <a id="btn-${childItem.id}">
                                            <img class="img" id='img-${childItem.id}'  src=${ isLight === 'true' ? require('../../../assets/images/angleRightColor.svg') : require('../../../assets/images/expand_more.png')} height="19">
                                                ${childItem.name}
                                        </a>
                                        </div>


                                        <div class="action-container">
                                            <div  class="action delete-action" id="delete-action-${childItem.id}" style="padding: 10px">
                                                <img class="imgBorderHandler" src=${require('../../../assets/images/trash.svg')}>
                                            </div>
                                            <div  class="action edit-action" id="edit-action-${childItem.id}" style="padding: 10px">
                                                <img class="imgBorderHandler" src=${require('../../../assets/images/edit.svg')}>
                                            </div>
                                        </div>
                                    </div>
                                 </div>
                                 <div id=${childItem.id}  style="display: none; border-left: 1px solid #E95626; padding-left: 20px" class="flex-column ms-3"></div>
                            </div>

                        `;

                        if(!this.permissions.includes('delete entity')){
                            document.getElementById(`delete-action-${childItem.id}`).style.cssText = `
                                padding: 10px;
                                cursor: not-allowed;
                        `;
                        }

                        if(!this.permissions.includes('update entity')){
                            document.getElementById(`edit-action-${childItem.id}`).style.cssText = `
                                padding: 10px;
                                cursor: not-allowed;
                        `;
                        }
                        this.getAllChildrens(childItem['all_children'])
                    })
                } else {
                    if (Array.isArray(data)) {
                        if (data.length > 0) {
                            data.forEach((sub_childItem, idx) => {
                                // console.log(" sub-child =>> ", sub_childItem)
                                let subChildren = document.getElementById(`${sub_childItem.parent_id}`);
                                document.getElementById(`delete-action-${sub_childItem.parent_id}`).style.cssText = `
                                padding: 10px;
                                cursor: not-allowed;
                        `;
                                subChildren.innerHTML += `
                            <div class="sub-children position-relative">
                            <span class="sub-child-border"></span>

                             <div class="sub-child-container" id="sub-child-container-${sub_childItem.id}" style="border-left: 4px solid #DBE2EA;">

                              <div class="d-flex justify-content-between">
                                    <div class="childrenBorderRight">
                                            <a id="btn-${sub_childItem.id}">
                                            <img class="img" id='img-${sub_childItem.id}'  src=${ isLight === 'true' ? require('../../../assets/images/angleRightColor.svg') : require('../../../assets/images/expand_more.png')} height="19">
                                                ${sub_childItem.name}
                                        </a>
                                        </div>


                                         <div class="action-container">
                                            <div  class="action delete-action" id="delete-action-${sub_childItem.id}" style="padding: 10px">
                                                <img class="imgBorderHandler" src=${require('../../../assets/images/trash.svg')}>
                                            </div>
                                            <div  class="action edit-action" id="edit-action-${sub_childItem.id}" style="padding: 10px">
                                                <img class="imgBorderHandler" src=${require('../../../assets/images/edit.svg')}>
                                            </div>
                                        </div>
                                    </div>

                                                            </div>

                                <div id=${sub_childItem.id}  style="display: none; border-left: 1px solid #E95626; padding-left: 20px" class="flex-column ms-3">

                                </div>
                            </div>
                        `;

                                if(!this.permissions.includes('delete entity')){
                                    document.getElementById(`delete-action-${sub_childItem.id}`).style.cssText = `
                                padding: 10px;
                                cursor: not-allowed;
                        `;
                                }

                                if(!this.permissions.includes('update entity')){
                                    document.getElementById(`edit-action-${sub_childItem.id}`).style.cssText = `
                                padding: 10px;
                                cursor: not-allowed;
                        `;
                                }
                                this.getAllChildrens(sub_childItem['all_children'])
                            })
                        }
                    }
                }
            },

            clickHandler(e) {
               let isLight = `${this.$store.state.settings.isLightMood}`;
                console.log({isLight})
                let id = null;
                if (e.target.closest("a") !== null) {
                    id = e.target.closest("a").id.split('-')[1];

                    let element = document.getElementById(id);

                    // console.log(id, element)
                    let elementImage = document.getElementById('img-' + id);
                    let displayStatus = element.style.display;
                    let parent = document.getElementById('parent-' + id);

                    let parentContainer = document.getElementById('parent-container-' + id);
                    let childContainer = document.getElementById('child-container-' + id);
                    let subChildContainer = document.getElementById('sub-child-container-' + id);

                    if (displayStatus === 'none') {


                        parent ? parent.style.borderLeftColor = '#E95626' : null;
                        childContainer ? childContainer.style.borderLeftColor = '#E95626' : null;

                        subChildContainer ? subChildContainer.style.borderLeftColor = '#E95626' : null;

                        parentContainer ? (parentContainer.style.backgroundColor = isLight === 'true' ? '#DDD' : '#335867') : null;
                        childContainer ? (childContainer.style.backgroundColor = isLight === 'true' ? '#DDD' : '#335867') : null;
                        subChildContainer ? (subChildContainer.style.backgroundColor = isLight === 'true' ? '#DDD' : '#335867') : null;

                        element.style.display = 'flex';
                        elementImage.src = isLight === 'true' ? require('../../../assets/images/expandMoreDownLight.svg') : require('../../../assets/images/expand_back.png');
                    } else if (displayStatus === 'flex') {
                        parent ? parent.style.borderLeftColor = '#DBE2EA' : null;
                        childContainer ? childContainer.style.borderLeftColor = '#DBE2EA' : null;

                        subChildContainer ? subChildContainer.style.borderLeftColor = '#DBE2EA' : null;

                        parentContainer ? parentContainer.style.backgroundColor = 'transparent' : null;
                        childContainer ? childContainer.style.backgroundColor = 'transparent' : null;
                        subChildContainer ? subChildContainer.style.backgroundColor = 'transparent' : null;
                        element.style.display = 'none';
                        elementImage.src = isLight === 'true' ? require('../../../assets/images/angleRightColor.svg') : require('../../../assets/images/expand_more.png');
                    }
                } else if (e.target.closest(".delete-action") !== null) {
                    let actionBtnCursorStyle = null;
                    id = e.target.closest(".action").id.split('-')[2];
                    // console.log(id);
                    actionBtnCursorStyle = document.getElementById('delete-action-' + id).style.cursor;
                    // console.log(actionBtnCursorStyle);
                    if (actionBtnCursorStyle !== 'not-allowed') {
                        // console.log('clickHandler', e.target, id);

                        this.confirmModalFlag = true;
                        this.confirmMessage = 'Do you want to delete this entity?';
                        this.entityId = id;
                    }
                } else if (e.target.closest(".edit-action") !== null) {
                    id = e.target.closest(".action").id.split('-')[2];
                    this.$router.push({path: '/settings/entities/edit/' + id});
                }
            },
            async confirmModalHandler(event) {

                this.confirmModalFlag = false;
                if (event) {
                    try {

                        let resData = await repository.delete('entities', this.entityId);
                        // this.$emit('update', this.entityId);
                        await this.entities.forEach((entity, idx) => {
                            console.log(entity, this.entityId)
                            if(entity.id === +this.entityId){

                                this.entities.splice(idx, 1);
                            }
                        });
                        this.init()
                        this.$store.dispatch('setSuccessModal', true);
                        this.$store.dispatch('setSueccessMessage', resData.data.message);


                    } catch (e) {
                        this.$store.dispatch('setErrorModal', true);
                        this.$store.dispatch('setErrorMessage', e.response.data.message);
                    }
                }
            }
        }
    }
</script>

<style>
    .imgBorderHandler{
        border: 1px solid var(--border-color-data-table);
    }
    .action .edit-action{
        border: 1px solid var(--border-color-data-table);
    }

    .childrenBorderRight{
        width: 48.5%;
        border-right: 2px solid var(--border-color-data-table);
        padding: 10px
    }

    .childCssColor{
        border-left: 4px solid var(--border-color-data-table);
    }

    .allDivCss{
        border:2px solid var(--border-color-data-table-for-entity);
        border-left: 0;
    }

    .parentStyleEntity{
        width: 50%;
        border-right: 2px solid var(--border-color-data-table-for-entity);
        border-left: 4px solid var(--border-left-entity);
        padding: 10px
    }

    .btn-container-no-data{
        height: 50px;
        width: 220px;
    }

    .tab-no-data-content{
        border-radius: 8px;
    }
    .page-container {
        padding: 22.5px;
    }

    .entity-title {
        color: #fff;
        font-size: 12px;
        padding: 6px 6px 6px 16px;
        border: 1px solid #0E223D;
        border-radius: 4px 4px 0 0;
        background-image: linear-gradient(to bottom, #044d6b, #044560, #043d54, #04354a, #042d3f);
    }


    .child-border {
        position: absolute;
        width: 22px;
        height: 1px;
        top: 25px;
        left: -21px;
        background-color: #E95626;
    }

    .sub-child-border {
        position: absolute;
        width: 20px;
        display: inline-block;
        height: 48px;
        border-bottom: 1px solid #E95626;
        top: -24px;
        left: -20px;
    }

    .child-container,
    .sub-child-container {
        /*padding: 10px;*/
        border: 2px solid var(--border-color-data-table);
    }

    /*.entities-section {*/
    /*    overflow-y: auto;*/
    /*    height: 80vh;*/
    /*}*/

    #tree-id {
        overflow-y: auto;
        height: 74.5vh;
    }

    .action-container {
        display: flex;
    }

    .action {
        cursor: pointer;
    }

    .parent-border {
        width: 100%;
        border-bottom: 1px solid rgb(233, 86, 38);
        position: absolute;
        top: 100%;
        left: 0;
    }

    .img {
        cursor: pointer;
    }
</style>
